<template>
  <div class="addSetContainer">
    <a-form-model
      v-if="details != ''"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目">
        <p>{{ details.project_name }}</p>
      </a-form-model-item>
      <a-form-model-item label="渠道">
        <p v-show="details.resume_source == 2">芜湖招聘部</p>
        <p v-show="details.resume_source == 3">{{ details.role_name }}</p>
        <p v-show="details.resume_source == 4">{{ details.company_name }}</p>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.resume_source == 3"
        label="底薪类型"
        ref="salary_type"
        prop="salary_type"
      >
        <a-radio-group v-model="form.salary_type">
          <a-radio :value="1">无责底薪</a-radio>
          <a-radio :value="2">有责底薪</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.resume_source == 3 && form.salary_type == 2"
        label="满足条件"
        ref="salary_type_person"
        prop="salary_type_person"
      >
        <a-input-number v-model="form.salary_type_person" :min="0" />
        <span>&nbsp;人</span>
      </a-form-model-item>
      <a-form-model-item label="结算方式" prop="statement_type">
        <a-radio-group v-model="form.statement_type" @change="selectType">
          <a-radio :value="1">出勤天数常规结算</a-radio>
          <a-radio :value="2">出勤天数阶梯结算</a-radio>
          <a-radio :value="3">时新结算</a-radio>
          <a-radio :value="4">订单/工单结算</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <!-- 模版一 -->
      <a-form-model-item
        label="出勤需满天数"
        prop="day"
        v-if="form.statement_type == 1 || form.statement_type == 2"
      >
        <a-input-number :min="0" v-model="form.day" />
        <span>&nbsp;天</span>
      </a-form-model-item>
      <!-- 模版 end一 -->
      <!-- 模版四 -->
      <a-form-model-item
        prop="hour"
        label="需满小时数"
        v-if="form.statement_type == 3"
      >
        <a-input-number v-model="form.hour" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 模版四 end -->
      <!-- 模版五 -->
      <a-form-model-item label="需满单量" v-show="form.statement_type == 4">
        <a-input-number v-model="form.order" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 模版五 end -->
      <a-form-model-item label="结算周期" prop="statement_cycle">
        <a-radio-group v-model="form.statement_cycle">
          <a-radio
            :value="item.id"
            v-for="(item, k) in dateTypeText"
            :key="k + 'k'"
            >{{ item.name }}</a-radio
          >
        </a-radio-group>
      </a-form-model-item>

      <!-- 一次性结算 长返 -->

      <a-form-model-item
        label="服务费"
        prop="service"
        v-if="form.statement_type == 1"
      >
        <a-input-number :min="0" v-model="form.service" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item
        label="每小时"
        prop="every_hour"
        v-if="form.statement_type == 3"
      >
        <a-input-number v-model="form.every_hour" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <a-form-model-item
        label="每单"
        prop="every_order"
        v-if="form.statement_type == 4"
      >
        <a-input-number v-model="form.every_order" />
        <span>&nbsp;元</span>
      </a-form-model-item>
      <!-- 一次性结算  长返 end -->
      <!-- 模版二 -->
      <a-form-model-item
        style="vertical-align: middle"
        v-if="form.statement_type == 2"
        label="阶梯"
      >
        <div v-for="(element, i) in step" :key="i + '1'">
          <span>累计人数&nbsp;&nbsp;</span>
          <a-input-number v-model="element.min" :min="0" />
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>累计人数&nbsp;&nbsp;</span>
          <a-input-number v-model="element.max" :min="element.min + 1" />
          <a-icon
            @click="addLadder(i, element.txt)"
            style="
              font-size: 32px;
              color: #999;
              vertical-align: middle;
              margin-left: 10px;
            "
            :type="element.txt == '增加' ? 'plus-square' : 'minus-square'"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item
        v-show="
          element.max != '' && form.statement_type == 2 && element.max != null
        "
        v-for="(element, j) in step"
        :key="j + 'element'"
        style="vertical-align: middle"
        label="服务费"
      >
        <span>{{
          element.min + "&nbsp;~&nbsp;" + element.max + "&nbsp;人&nbsp;&nbsp;"
        }}</span>
        <a-input-number
          v-model="element.service"
          :min="0"
          style="margin-right: 10px"
        />
        <span>元</span>
      </a-form-model-item>
      <!-- 模版二 end -->
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button @click="resetForm('ruleForm')"> 重置 </a-button>
        <a-button style="margin-left: 20px" type="primary" @click="onSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        statement_type: 1,
        statement_cycle: "",
        monthCost: "",
        resume_source: "",
        project_id: "",
        job: "",
        resume_third_id: "",
        day: "",
        hour: "",
        order: "",
        service: "",
        every_order: "",
        every_hour: "",
        salary_type: 1,
        salary_type_person: ""
      },
      rules: {
        every_hour: [
          {
            required: true,
            message: "请输入时薪",
            trigger: "blur"
          }
        ],
        every_order: [
          {
            required: true,
            message: "请输入单价",
            trigger: "blur"
          }
        ],
        service: [
          {
            required: true,
            message: "请输入服务费",
            trigger: "blur"
          }
        ],
        order: [
          {
            required: true,
            message: "请输入需满单量",
            trigger: "blur"
          }
        ],
        hour: [
          {
            required: true,
            message: "请输入需满小时数",
            trigger: "blur"
          }
        ],
        day: [
          {
            required: true,
            message: "请输入出勤需满天数",
            trigger: "blur"
          }
        ],
        resume_third_id: [
          {
            required: true,
            message: "请选择三方",
            trigger: "change"
          }
        ],
        job: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change"
          }
        ],
        statement_type: [
          {
            required: true,
            message: "请选择结算方式",
            trigger: "change"
          }
        ],
        salary_type_person: [
          {
            required: true,
            message: "请填写满足条件",
            trigger: "blur"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        resume_source: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        statement_cycle: [
          {
            required: true,
            message: "请选择结算周期",
            trigger: "change"
          }
        ]
      },
      step: [{ min: 0, max: "", txt: "增加", service: "" }],
      costList: [],
      disabled: false,
      dateTypeText: [
        {
          name: "一次性结算",
          id: 1
        },
        {
          name: "长返",
          id: 2
        }
      ],
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      checked: false,
      thirdList: [],
      roleList: [],
      isSelectType: false,
      details: ""
    };
  },
  computed: {
    monthCostComputed() {
      return this.form.monthCost;
    }
  },
  props: {
    editDetails: {}
  },
  mounted() {
    this.getProOne(); //获取一级项目列表
    this.getPro();
    this.getThirdParty(); //三方公司
    this.getRole();
    if (this.editDetails != undefined) {
      this.getDetails();
    }
  },
  watch: {
    editDetails() {
      this.getDetails();
    },
    monthCostComputed() {
      if (Number(this.form.monthCost) > 0) {
        this.costList.length = Number(this.form.monthCost);
      }
    }
  },
  methods: {
    getDetails() {
      this.details = this.editDetails;
      // console.log(this.details);
      this.form = {
        statement_type: this.details.statement_type,
        statement_cycle: this.details.statement_cycle,
        monthCost: this.details.monthCost,
        project_id: this.details.project_id,
        resume_source: this.details.resume_source,
        job: this.details.job,
        resume_third_id: this.details.resume_third_id,
        day: this.details.day,
        hour: this.details.hour,
        order: this.details.order,
        service: this.details.service,
        every_order: this.details.every_order,
        every_hour: this.details.every_hour,
        salary_type: this.details.salary_type,
        salary_type_person: this.details.salary_type_person
      };
      // console.log(this.details.step)
      if (this.details.step != undefined && this.details.step != "") {
        this.step = [];
        this.details.step.forEach(element => {
          if (element == 0) {
            this.step.push({
              min: element.min,
              max: element.max,
              service: element.service,
              txt: "增加"
            });
          } else {
            this.step.push({
              min: element.min,
              max: element.max,
              service: element.service,
              txt: "减少"
            });
          }
        });
      } else {
        this.step = [{ min: 0, max: "", txt: "增加", service: "" }];
      }
    },
    getRole() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 1000,
          role_type: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
            // console.log(this.roleList);
          }
        });
    },
    selectType() {
      if (this.form.statement_type == 2) {
        this.isSelectType = true;
        this.form.resume_source = [4]; //阶梯计算方式只有三方公司
        this.form.job = "";
        this.$forceUpdate();
      } else {
        this.isSelectType = false;
      }
    },
    getThirdParty() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    selectedAll(e) {
      this.checked = e.target.checked;
      if (this.selectedOneVal == "") {
        this.project_id = [];
      }
      if (e.target.checked) {
        this.proListThree.forEach(element => {
          if (this.project_id.indexOf(element.id) == -1) {
            // console.log(element.id)
            this.project_id.push(element.id);
          }
          // console.log(element)
        });
      } else {
        this.project_id = [];
      }
    },
    selectedOne(id) {
      this.checked = false;
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.getProID(id, 1); //获取下级项目
      this.getThreePro(id);
      // console.log(id);
    },
    selectedTwo(id) {
      this.checked = false;
      this.isShowThree = true;
      this.getProID(id, 2); //获取下级项目
    },
    getThreePro(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectTop";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            // console.log(this.proListThree);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.people +
            "Recruitment_cost/edit";
          let step = [];
          this.step.forEach(item => {
            step.push({
              min: item.min,
              max: item.max,
              service: item.service
            });
          });
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            project_id: JSON.stringify(this.form.project_id),
            resume_source: JSON.stringify(this.form.resume_source),
            resume_third_id: JSON.stringify(this.form.resume_third_id),
            statement_type: this.form.statement_type,
            day: this.form.day,
            hour: this.form.hour,
            order: this.form.order,
            statement_cycle: this.form.statement_cycle,
            service: this.form.service,
            every_hour: this.form.every_hour,
            every_order: this.form.every_order,
            step: JSON.stringify(step),
            job: this.form.job,
            salary_type: this.form.salary_type,
            salary_type_person: this.form.salary_type_person,
            id: this.details.id
          };
          if (this.form.statement_type != 2) {
            delete params.step;
          }
          if (!this.form.resume_source == 3) {
            delete params.job;
            delete params.salary_type;
            delete params.salary_type_person;
          }
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$emit("hideInEdit", false);
              this.resetForm("ruleForm");
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.isSelectType = false;
      this.$refs[formName].resetFields();
    },
    addLadder(index, txt) {
      if (txt == "增加") {
        if (this.step[this.step.length - 1].max != "") {
          this.step.push({
            min: this.step[this.step.length - 1].max,
            max: "",
            txt: "减少",
            service: ""
          });
        } else {
          this.$message.error("请先填写最大值！");
        }
      } else {
        this.step.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less">
.addSetContainer {
  margin: 30px 2% 50px;
  padding-bottom: 30px;
  .ant-form-item {
    margin-bottom: 14px;
  }
  .ant-form-item label {
    margin-bottom: 10px;
  }
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
}
</style>
